import { Shipment } from "..";

export class ShipmentContract extends Shipment {
      contractTypeId?: number
      shipmentId?: number
      companyNameA?: string
      companyAddressA?: string
      companyPhoneA?: string
      taxCodeA?: string
      representA?: string
      representRoleA?: string
      companyNameB?: string
      companyAddressB?: string
      companyPhoneB?: string
      taxCodeB?: string
      representB?: string
      representRoleB?: string
      advancePayment?: string
      advancePaymentType?: string
      lastPaymentType?: string
      header?: string
      rules?: string
      createdWhen?: Date
      createdBy?: number
      modifiedWhen?: Date
      modifiedBy?: number
}